import React from 'react'
import { Link } from 'react-router-dom'
import { Fade } from "react-awesome-reveal";
import icon from '../../images/icon/magic.png'
import about1 from '../../images/icon/airdrop.png'
import about2 from '../../images/icon/people.png'
import about3 from '../../images/icon/microphone.png'

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section id="about" className="about m-lr mb-100 mt-100">
            <div className="about-wrapper sec-bg pos-rel pb-130 pt-130">
                <div className="container">
                    <div className="sec-title--two text-center">
                        <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                <img src={icon} alt="" /> We are TechStr
                            </div>
                        </Fade>
                        <Fade direction='down' triggerOnce={'false'} duration={1500} delay={9}>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">More Than a Company, Committed to Excellence</h2>
                        </Fade>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 mt-50">
                            <div className="about-left">
                                <h2 className="title">Core values</h2>
                                <div className="about-item_box ul_li">
                                    <div className="xb-item--icon"><img src={about1} alt="" /></div>
                                    <div className="xb-item--holder">
                                        <p className="xb-item--content"><span>Innovation:</span> We embrace emerging technologies and methodologies to provide cutting-edge solutions.</p>
                                    </div>
                                </div>
                                <div className="about-item_box ul_li">
                                    <div className="xb-item--icon"><img src={about2} alt="" /></div>
                                    <div className="xb-item--holder">
                                        <p className="xb-item--content"><span>Integrity:</span>Our business practices are rooted in honesty, transparency, and ethical standards.</p>
                                    </div>
                                </div>
                                <div className="about-item_box ul_li">
                                    <div className="xb-item--icon"><img src={about3} alt="" />
                                    </div>
                                    <div className="xb-item--holder">
                                        <p className="xb-item--content"><span>Excellence:</span> We strive for superior quality in every project, ensuring measurable results & client satisfaction.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-50">
                            <div className="about-right">
                                <div className="xb-item--holder">
                                    <h2 className="xb-item--title">Our Mission</h2>
                                    <p className="xb-item--content">At TechStr, we empower businesses with cutting-edge ServiceNow solutions, streamlining operations, enhancing efficiency, and driving digital transformation for sustained growth.</p>
                                </div>
                                <div className="xb-item--holder">
                                    <h2 className="xb-item--title">Our Vision</h2>
                                    <p className="xb-item--content">To be a global leader in ServiceNow consulting, enabling businesses to innovate, optimize workflows, and achieve seamless digital excellence.</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className="xb-btn text-center mt-90 wow fadeInUp" data-wow-duration="600ms">
                            <Fade direction='up' triggerOnce={'false'} duration={1500} delay={9}>
                                <Link onClick={ClickHandler} to="/about" className="thm-btn thm-btn--aso">Learn more about us</Link>
                            </Fade>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;